<div class="flex items-center gap-base">
  <lla-dropdown-menu
    [bottomSheet]="true"
    class="flex-1"
    extraClass="bg-contrast !w-auto"
    icon="arrow-down-simple"
    [items]="items"
    [selectedItem]="sortState?.active"
    (selectedItemChanged)="
      onSortChanged({
        column: $event
      })
    "
    placeHolder="Sort by"
  >
  </lla-dropdown-menu>

  <div
    class="w-[126px] p-sm flex items-center justify-between gap-sm bg-contrast border border-ui-separator rounded-sm cursor-pointer"
    (click)="
      onSortChanged({
        direction: sortState?.direction === 'asc' ? 'desc' : 'asc'
      })
    "
  >
    <div class="flex-1 text-base leading-base text-txt">
      {{ sortState?.direction === 'asc' ? 'Ascending' : 'Descending' }}
    </div>
    <div class="flex" [ngClass]="{ 'rotate-180': sortState?.direction === 'asc' }">
      <svg-icon key="arrow-up-full" class="!text-sm text-gray-400"></svg-icon>
    </div>
  </div>
</div>
